import { transform } from "inflection"

export function slugify(str: string): string {
  return transform(str, ['dasherize']).toLowerCase()
}